export interface ValueWithLabel {
  value: string;
  label: string;
}

export enum UserRole {
  STUDENT = "student",
  TEACHER = "teacher",
  DISTRIBUTOR = "distributor",
  COORDINATOR = "coordinator",
  HR = "hr",
  PAYROLL_ACCOUNTANT = "payroll_accountant",
  USER = "user",
}

export class StoreMismatchError extends Error {}
